import React from 'react';

import { Column, useTable } from 'react-table';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export interface IOrderDetailsTable {
  data: readonly object[];
  columns: Array<Column>;
  noDataText?: string;
}

function OrderDetailsTable({ columns, data, noDataText }: IOrderDetailsTable) {
  const tableStyle = { minWidth: 650 };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  const noDataPlaceholder = () => {
    let text: string;

    if (!noDataText) {
      text = 'Data unavailable';
    } else {
      text = noDataText;
    }

    return text;
  };

  return (
    <TableContainer>
      <Table
        style={tableStyle}
        aria-label='simple table'
        size='small'
        {...getTableProps()}>
        <caption
          style={{
            textAlign: 'center',
            display: data && data.length > 0 ? 'none' : 'table-caption',
          }}>
          {data && data.length > 0 ? '' : noDataPlaceholder()}
        </caption>
        <TableHead>
          {headerGroups.map((headerGroup, index) => (
            <TableRow {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column) => (
                <TableCell {...column.getHeaderProps()} key={column.id}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <TableRow
                {...row.getRowProps()}
                key={`row-${i}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                {row.cells.map((cell, j) => {
                  return (
                    <TableCell
                      {...cell.getCellProps()}
                      key={`row-${i}--column-${j}`}>
                      {cell.render('Cell')}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default OrderDetailsTable;
